<template>
    <v-container class="registerUser fill-height" fluid>
        <v-row class="registerUser__register" align="center" justify="center">
            <v-col cols="12" md="8">
                <Register />
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import Register from "../../../components/Applicants/Authentication/Register.vue"

export default {
    components: {
        Register
    }
}
</script>

<style scoped>
.registerUser {
    background-image: url('../../../assets/background/unauthenticated_bg.png');
    background-size: cover;
    background-repeat: no-repeat;
    background-attachment: fixed;
    background-position: center center;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
}
</style>